module.exports = ".progress-message {\n    margin-bottom: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/progress-bar/progress-bar.component.css
// module id = ./src/app/components/progress-bar/progress-bar.component.css
// module chunks = main